import { theme } from 'styles/theme/hav-theme'
import * as S from './styles'

export type ButtonVariants =
  | 'primary'
  | 'secondary'
  | 'white'
  | 'success'
  | 'warning'
  | 'info'
  | 'danger'
  | 'transparent'
  | 'ghost'
  | 'icon'

export type SlimButtonProps = {
  id?: string
  type?: 'button' | 'submit' | 'reset'
  variant: ButtonVariants
  size?: keyof typeof theme.sizes.buttons
  /** @deprecated Use `size` prop instead height */
  height?: number
  content?: string
  disabled?: boolean
  loading?: boolean
  icon?: React.ReactNode // TODO: Remove React.ReactNode after all icons are migrated to (keyof typeof icons)
  iconColor?: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  'data-testid'?: string
}

export const SlimButton: React.FC<SlimButtonProps> = ({
  id,
  type,
  variant,
  size = 'md',
  height = size ? undefined : 36, // 36 = size.md
  content,
  disabled,
  loading,
  icon,
  iconColor,
  onClick,
  'data-testid': dataTestId
}) => {
  const showContent = !!content && variant !== 'icon'

  return (
    <S.StyledButton
      id={id}
      type={type}
      variant={variant}
      size={size}
      height={height}
      disabled={disabled}
      loading={loading}
      onClick={onClick}
      iconColor={iconColor}
      data-testid={dataTestId}
    >
      {!!icon && icon} {/* TODO: Set icon size whit button size */}
      {showContent && <S.ButtonText size={size || 'md'}>{content}</S.ButtonText>}
    </S.StyledButton>
  )
}
